import { Component, ContentChild, ElementRef, EventEmitter, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, input } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import { Router } from '@angular/router';
import { ScrollService } from 'src/app/services/scroll/scroll.service';
import { AbstractControl, FormGroup } from '@angular/forms';
import * as s from './accordion-item.component.strings';
import * as constantsStrings from '../../constants/strings';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    imports: [NgClass, NgTemplateOutlet]
})

export class AccordionItemComponent implements OnInit, OnChanges, OnDestroy {

    public strings = s;
    public constants = constantsStrings;
    public active: boolean = false;
    public accordionChange: any;

    readonly activate = input<number>(undefined);
    readonly disableEditMode = input<boolean>(false);
    readonly inlineHeader = input<boolean>(false);
    readonly control = input<AbstractControl>(undefined);
    readonly index = input<number>(undefined);
    @Output() editToggled: EventEmitter<number> = new EventEmitter();
    @Output() preEditToggle: EventEmitter<number> = new EventEmitter();

    @ContentChild('content') content: TemplateRef<any>;
    @ContentChild('header') header: TemplateRef<any>;

    @ViewChild('scrollTarget', { static: true }) scrollTarget: ElementRef;

    constructor(
        private googleTagManagerService: GoogleTagManagerService,
        private scrollService: ScrollService
    ) { }
    
    ngOnInit(): void {
        this.accordionChange = this.control()?.get('editMode')?.valueChanges.subscribe((change) => {
            //scroll to accordion header on manual close with 'done' btn
            if (!change) {
                setTimeout(() => (this.scrollService.scrollToElement(this.scrollTarget, -100))
                    , 0);
            }
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.activate) {
            this.active = this.activate() == this.index();
        }
    }

    ngOnDestroy(): void {
        let editMode = this.control()?.get('editMode');
        if (editMode?.value === true) {
            editMode?.setValue(false, { emitEvent: false, onlySelf: true });
        }
        this.accordionChange?.unsubscribe();
    }

    public getIsEditMode(control: AbstractControl, index: number): boolean {
        let result = false;
        if (control && typeof (FormGroup)) {
            result = control?.get('editMode')?.value === true;
        }
        return result;
    }

    public toggleEditMode(control: AbstractControl, index: number): void {
        this.preEditToggle.emit(index);
        if (control && typeof (FormGroup) && !this.disableEditMode()) {
            let htmlId = this.getImageId(control, index);
            let editMode = control.get('editMode');
            if (editMode?.value === true) {
                editMode?.setValue(false, { emitEvent: false, onlySelf: true });
                this.active = false;
                this.googleTagManagerService.trackAction(this.strings.gtmEvent, "close", htmlId, this.control()?.get('title')?.value);
            } else {
                editMode?.setValue(true);
                this.active = true;
                this.googleTagManagerService.trackAction(this.strings.gtmEvent, "open", htmlId, this.control()?.get('title')?.value);
                setTimeout(() => (this.scrollService.scrollToElement(this.scrollTarget, -100))
                    , 0);
            }
            this.editToggled.emit(index);
        }
    }

    public getImageId(dataItem, index: number): string {
        return this.getIsEditMode(dataItem, index) ?
            this.constants.AccordionClose + index :
            this.constants.AccordionOpen + index
    }
}
